import type { EditAssetWorkflowOptions } from '../../types';

export const deleteScheduleEntryWorkflow: EditAssetWorkflowOptions = {
  workflowKey: 'deleteScheduleEntryWorkflow',
  workflowType: 'editAssetWorkflow',
  assetType: 'schedule',
  workflowIndex: 3,
  workflowName: 'Delete Schedule Entry',
  workflowActionIcon: 'EditOutlined',
  hideIfDisabled: true,
  workflowStateTransformFunction: (assetPayload: any, asset: any) => {
    // because of the way the form state was intially managed
    // I need this weird hack
    // I should be able to change this to something more sensible once I move over to the
    // setWorkflowFormatter pattern
    const from = assetPayload.scheduleEntry;
    const deleteConfirm = assetPayload.deleteConfirm;
    asset.entries = asset.entries.filter((e: any) => {
      return e.from !== from || !deleteConfirm ? e : null;
    });
    return asset;
  },
  assetSchemaMatcher: {
    type: 'object',
    properties: {
      archived: { type: 'boolean', const: false },
      active: { type: 'boolean', const: true },
    },
  },
  workflowStepOptions: [
    {
      workflowStepKey: 'selectScheduleEntry',
      workflowStepNavigationName: 'Update Schedule',
      workflowComponent: {
        workflowComponentType: 'scheduleEditEntry',
        prompt: 'What schedule entry do you want to delete',
        description: 'Select the date of the schedule entry you want to delete',
        help: '',
        dateOnly: true,
      },
      calculatedComponentProps: {
        scheduleId: {
          property: 'scheduleId',
          type: 'asset',
        },
      },
      workflowStateToAssetMapping: {
        mappingType: 'property',
        property: 'scheduleEntry',
      },
    },
    {
      workflowStepKey: 'confirmScheduleDelete',
      workflowStepNavigationName: 'Confirm Schedule Delete',
      workflowComponent: {
        workflowComponentType: 'singleSelect',
        prompt: 'Are you sure you want to delete?',
        description: 'This is not reversible!',
        help: '',
        dateOnly: true,
        options: [
          { optionText: 'Yes Delete Forever', optionValue: true },
          { optionText: 'Cancel', optionValue: false },
        ],
      },
      workflowStateToAssetMapping: {
        mappingType: 'property',
        property: 'deleteConfirm',
      },
    },
    {
      workflowStepKey: 'summary',
      workflowStepNavigationName: 'Configuration Summary',
      workflowComponent: {
        workflowComponentType: 'workflowSummary',
        title: 'Delete Schedule Summary',
        description: 'The schedule will be permenantly deleted.  Please review your selections.',
        help: '',
      },
      workflowStateToAssetMapping: {
        mappingType: 'ignore',
      },
    },
  ],
};
